import { ModuleDetail } from '../interfaces/Organization';
import { MCurrentVersion } from './current-version.model';

export class MModuleDetail{
  public id: number;
  public name: string;
  public public: boolean;
  public versions: MCurrentVersion[];
  public description: string;

  constructor(module:ModuleDetail){
    this.id = module.id;
    this.name = module.nombre;
    this.public = module.publico;
    this.versions = [];
    this.description = module.descripcion;
    if (module.versiones_modulos) {
      for (let i = 0; i < module.versiones_modulos.length; i++) {
        this.versions.push(new MCurrentVersion(module.versiones_modulos[i]))        
      }
    } else {
      this.versions = null;
    }
  }

}